import React, { useState } from 'react';

import { Alert } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import styled from 'styled-components';

import { NwButton } from '@components/Gui/NwButton';
import { NWInput } from '@components/Gui/NwForm/NwFormItems';
import { NwForm } from '@components/Gui/NwForm/NwFormWrapper';
import NwModal from '@components/Gui/NwModal';

import { usePackageContext } from '../PackageContext';

const FormItem = styled.div`
    display: flex;
    align-items: flex-start;

    .field-container {
        width: 100%;
    }
    .ant-form-item {
        margin-bottom: 0;
    }
`;

const NewGroupModal = ({ onClose }) => {
    const [touchForm, setTouchForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const packageContextValue = usePackageContext();
    const { groupedPackage } = packageContextValue;
    const groupNames = groupedPackage.GroupNames;

    let initialValues = {
        GroupName: '',
    };

    const onCreateNewGroup = async (groupName) => {
        //check if group already exists
        if (groupNames && groupNames.find((name) => name === groupName)) {
            setErrorMessage('Group already exists');
            return;
        }
        onClose(groupName);
    };

    const submitForm = async (values, setSubmitting) => {
        setSubmitting(true);
        await onCreateNewGroup(values.GroupName);
        setSubmitting(false);
    };

    return (
        <NwModal
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            title="New Package Group"
            open
            footer={null}
            onCancel={() => {
                onClose();
            }}
        >
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                    GroupName: Yup.string().required('Content is required'),
                })}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    submitForm(values, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit} layout="vertical">
                        <FormItem>
                            <Field component={NWInput} name="GroupName" type="text" value={values.GroupName} />
                            &nbsp;
                            <NwButton
                                htmlType="submit"
                                primary
                                disabled={isSubmitting}
                                loading={isSubmitting}
                                label="Save"
                                loadingLabel="Updating..."
                            />
                        </FormItem>
                    </NwForm>
                )}
            </Formik>
            {errorMessage && <Alert type="error" message={errorMessage} />}
        </NwModal>
    );
};

export default NewGroupModal;
